import React from "react";
import { Fade, Roll, Zoom } from "react-reveal";
import Shake from "react-reveal/Shake";
import Typed from "react-typed";
import resume from "../assets/img/pdf/Ashraful_Islam.pdf";
import ProfileImg from "../assets/img/profile.jpeg";

const Hero = () => {
  return (
    <section
      id="home"
      className="lg:h-[85vh] flex items-center bg-gradient-to-r from-[#24263b] to-[#293068] lg:bg-cover lg:bg-center lg:bg-no-repeat py-32 lg:py-0 overflow-hidden"
    >
      <div className="container mx-auto h-full">
        <div className="flex items-center h-full pt-8">
          <div className="flex-1 flex flex-col items-center lg:items-start">
            <Roll left>
              <p className="text-xl text-accent pt-10 text-md mb-[22px] flex">
                Hey, I'm Ashraful Islam! <Shake>👋</Shake>
              </p>
            </Roll>
            <Fade left>
              <div className="text-3xl text-white leading-[44px] md:text-4xl md:leading-tight lg:text-5xl lg:leading-[1.2] font-bold md:tracking-[-2px]">
                I Am&nbsp;
                <span className="text-accent">
                  <Typed
                    strings={[
                      "Software Engineer",
                      "Web Developer",
                      "MERN Stack Developer",
                      "Freelancer",
                    ]}
                    typeSpeed={40}
                    backSpeed={50}
                    loop
                  ></Typed>
                </span>
              </div>
            </Fade>
            <Fade right>
              <p className="pt-4 pb-8 md:pt-6 md:pb-12 max-w-[480px] text-lg text-center lg:text-left">
                I Creates Any Types Of Website With Responsive.I consider myself
                As a fully dedicated, dynamic, punctual, efficient, quick
                responder, and also very convivial.
              </p>
              <a href={resume} download>
                <Zoom top>
                  <button className="btn btn-md bg-accent hover:bg-secondary-hover md:btn-lg transition-all">
                    Download My Resume
                  </button>
                </Zoom>
              </a>
            </Fade>
          </div>
          <Zoom left>
            <div className="hidden lg:flex flex-1 justify-center   rounded-full  items-center ">
              <div className="w-[25rem] h-[25rem]  border border-gray-50 rounded-full">
                <div className="ml-2">
                  <img
                    className="object-cover hover:scale-110 transition-all duration-1000 rounded-full w-[24rem] h-[24rem]"
                    src={ProfileImg}
                    alt=""
                  />
                </div>
              </div>
            </div>
          </Zoom>
        </div>
      </div>
    </section>
  );
};

export default Hero;
